<template>
  <div>
    <callTestResultsTable :sharedLinkView="true" :callTestRequest="broadcast" :liveDataResults='liveDataResults' :numberOfCalls="number_of_calls" :testFinalStatus="testFinalStatus"></callTestResultsTable>
  </div>
</template>

<script>
import Vue from "vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "devegram-vue-data-collecter-eui/src/css/style.css"
import "ag-grid-community/dist/styles/ag-theme-bootstrap.min.css";
import "ag-grid-community/dist/styles/ag-theme-material.min.css";
import "devegram-vue-data-collecter-eui/src/export.js"
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import Paginate from 'vuejs-paginate'
import ElementUI from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import '@/components/export'

import {notify} from '@/system-services/notify.js'
locale.use(lang)
$vue.use(ElementUI);
$vue.component('paginate', Paginate)

export default {
  components: {
    callTestResultsTable: () => import('@/components/call-test-results-table/View')
  },
  async beforeMount() {
    if (!this.$store.hasModule('voip-testing-panel-api')) {
      let { default: importedModule } = await import('@/modules/voip-testing-panel/store/api.js')
      this.$store.registerModule('voip-testing-panel-api', importedModule)
    }

    let braodcastPublicId = this.$route.params.broadcastPublicId
    braodcastPublicId = braodcastPublicId.split('-')
    let apiParams = {publicId: braodcastPublicId[0]}

    if (braodcastPublicId.length == 2) {
      apiParams.mrt = 1
    }

    this.getBroadcastCdrByPublicId(apiParams).then(response => {
      let cdr = response.data
      this.broadcast = cdr
      this.liveDataResults = JSON.parse(cdr.cdr_json)
      this.number_of_calls = cdr.number_of_calls
      this.testFinalStatus = cdr.system_call_test_status_id
    })
  },
  methods: {
    ...$mapActions('voip-testing-panel-api', {
      getBroadcastCdrByPublicId: 'getBroadcastCdrByPublicId'
    })
  },
  data () {
    return {
      testFinalStatus: 0,
      number_of_calls: -1,
      liveDataResults: [],
      broadcast: null
    }
  }
}
</script>
